import axios from 'axios';
import { DataSourceItem, DataSourceType } from '../types/DataSource';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export interface DataSourceQueryParams {
  source: DataSourceType;
  search?: string;
}

export interface DataSourcePayload {
  source: DataSourceType;
  name: string;
  type?: string;
  property?: string;
  code: string;
}

class DataSourcesService {
  async getDataSources(params: DataSourceQueryParams): Promise<DataSourceItem[]> {
    const response = await axios.get(`${API_URL}/admin/data-sources`, { params });
    return response.data;
  }

  async createDataSource(payload: DataSourcePayload): Promise<DataSourceItem> {
    const response = await axios.post(`${API_URL}/admin/data-sources`, payload);
    return response.data;
  }

  async updateDataSource(id: number, payload: Omit<DataSourcePayload, 'source'>): Promise<DataSourceItem> {
    const response = await axios.put(`${API_URL}/admin/data-sources/${id}`, payload);
    return response.data;
  }

  async deleteDataSource(id: number): Promise<void> {
    await axios.delete(`${API_URL}/admin/data-sources/${id}`);
  }
}

export const dataSourcesService = new DataSourcesService();
export default dataSourcesService;
